module.exports = __webpack_public_path__ + "media/images/logos/forbes-2ed97966b881e4f55407fd904709775b.png";